module.exports = __webpack_public_path__ + "static/media/default-bg.ce7f8f8a.jpg";